import * as types from '../../utils/actionTypes'


const setBudgetIgnoreAction = payload => ({
  type: types.SET_BUDGET_IGNORE,
  payload,
})

export const setBudgetIgnore = payload =>
  dispatch => dispatch(setBudgetIgnoreAction(payload))

const setBudgetSelection = payload => ({
  type: types.SET_BUDGET_SELECTION,
  payload,
})

const setHandleValue = payload => ({
  type: types.SET_BUDGET_VALUE,
  payload,
})

export const setBudgetValue = payload =>
  (dispatch) => {
    dispatch(setHandleValue(payload))
    dispatch(setBudgetSelection(payload))
  }


const setHandleBlock = payload => ({
  type: types.SET_BUDGET_BLOCK,
  payload,
})

export const setBudgetBlock = payload =>
  dispatch => dispatch(setHandleBlock(payload))



// WEBPACK FOOTER //
// ./src/modules/budget/actions.js